import { defineMessages } from '@redbubble/next/intl';

export const messages = defineMessages({
  previewAltText: {
    defaultMessage:
      'Item preview, {workTitle} designed and sold by {artistName}.',
  },
  previewAltTextFallback: {
    defaultMessage: 'Item preview.',
  },
});
